<template>
  <div class="transport-tabs-wrapper">
    <el-tabs v-model="activeTab" class="transport-tabs" :tab-position="'top'" @tab-click="changeTab">
      <el-tab-pane label="特惠TIR" name="TIR">
        <div class="transport-card-list" v-if="transportList.length!=0">
          <div
            v-for="(item, index) in transportList"
            :key="index"
            class="transport-card"
          >
            <div class="route">
              
              <span class="from">{{item.custStartPlaceName.split(",")[0].split(";").at(-1)}}</span>
              <!-- 包裹箭头和价格的容器 -->
              <div class="arrow-price-container">
                <!-- 价格显示在箭头上方 -->
                <span class="price">{{ item.carMode3TIR }}{{ item.carMode3currTIR }}</span>
                <!-- 长横线箭头 -->
                <div class="long-arrow">
                  <i class="el-icon-arrow-right arrow-icon"></i>
                </div>
              </div>
              <span class="to">{{item.custEndPlaceName.split(",")[0].split(";").at(-1)}}</span>
            </div>
            <div class="validity">
              <div>价格有效期: {{ item.effectiveDate }}</div>
              <div class="to-get-car" @click="toGetCar">去定车</div>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-if="transportList.length==0">暂无特惠TIR信息</div>
      </el-tab-pane>
      <el-tab-pane label="转关运输" name="">
        <div class="transport-card-list" v-if="transportList.length!=0">
          <div
            v-for="(item, index) in transportList"
            :key="index"
            class="transport-card"
          >
            <div class="route">
              <span class="from">{{item.custStartPlaceName.split(",")[0].split(";").at(-1)}}</span>
              <!-- 包裹箭头和价格的容器 -->
              <div class="arrow-price-container">
                <!-- 价格显示在箭头上方 -->
                <span class="price">{{ item.carMode3 }}{{ item.carMode3curr }}</span>
                <!-- 长横线箭头 -->
                <div class="long-arrow">
                  <i class="el-icon-arrow-right arrow-icon"></i>
                </div>
              </div>
              <span class="to">{{item.custEndPlaceName.split(",")[0].split(";").at(-1)}}</span>
            </div>
            <div class="validity">
              <div>价格有效期: {{ item.effectiveDate }}</div>
              <div class="to-get-car" @click="toGetCar">去定车</div>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-if="transportList.length==0">暂无转关运输信息</div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="联系我们"
      :visible.sync="showDialog"
      width="500px"
      :show-close="true"
      :modal="false"
      class="contact-dialog"
    >
      <div class="dialog-content">
        <!-- 左侧二维码 -->
        <div class="qrcode-wrapper">
          <div class="qrcode-container">
            <img src="@/assets/img/qrCode1.png" alt="联系二维码" class="qrcode-img" />
          </div>
        </div>

        <!-- 右侧联系方式 -->
        <div class="contact-info">
          <div class="contact-item">
            <div class="icon-wrapper phone-icon">
              <i class="el-icon-phone-outline"></i>
            </div>
            <span class="contact-text">17318410357</span>
          </div>
          <div class="contact-item">
            <div class="icon-wrapper email-icon">
              <i class="el-icon-message"></i>
            </div>
            <span class="contact-text">jiangxinni1@mastery.net.cn</span>
          </div>
        </div>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
export default {
  name: 'TransportTabs',
  data() {
    return {
      activeTab: 'TIR',
      showDialog: false,
      transportList: [
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
        { price: '105000RMB', validity: '2026-05-22 00:00:00' },
      ]
    }
  },
  methods: {
    changeTab() {
      window.console.log(12321);
      this.loadData()
    },
    toGetCar() {
      this.showDialog = true
    },
    loadData() {
              const params = {
                size: 36,
                page: 1,
                type: this.activeTab
              }
            this.$http
        .post(`/public-supplier/scheduleHighway/pageList-adyl`,params)
        .then(response => {
          //console.log(response);
          this.transportList = response.data.data.content;
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>
.line-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 400px;
  background: #000;
}
.transport-tabs-wrapper {
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* Tab居中样式 */
.transport-tabs >>> .el-tabs__header {
  margin: 0;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e4e7ed;
}

/* Tab居中样式 */
.transport-tabs >>> .el-tabs__header {
  margin: 0;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e4e7ed;
}

.transport-tabs >>> .el-tabs__nav-wrap {
  margin: 0;
  float: none !important;
}

.transport-tabs >>> .el-tabs__nav {
  float: none !important;
}

.transport-tabs {
  --el-tabs-header-height: 60px;
}

.transport-tabs >>> .el-tabs__item {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
  height: 45px;
  line-height: 45px;
  padding: 0 30px;
}

.transport-tabs >>> .el-tabs__item.is-active {
  color: #409eff;
  font-weight: 600;
}

.transport-tabs >>> .el-tabs__active-bar {
  background-color: #409eff;
  height: 3px;
  margin: 0 auto;
}


/* 卡片列表布局 */
.transport-card-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
}

.transport-card {
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.transport-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
}
.el-dialog__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
}
/* 路线容器 */
.route {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 16px;
  width: 100%;
  position: relative;
}

.from, .to {
  color: #303133;
  font-weight: 500;
  white-space: nowrap;
  /* 固定出发/到达地宽度，保证横线居中 */
  text-align: center;
}

/* 箭头+价格容器 - 核心样式 */
.arrow-price-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
}

/* 价格样式 - 显示在箭头上方 */
.price {
  color: #f56c6c;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 5px; /* 价格和箭头之间的间距 */
}

/* 长横线箭头样式 */
.long-arrow {
  width: 100%; /* 宽度铺满容器 */
  height: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 长横线 */
.long-arrow::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #dcdfe6;
  transform: translateY(-50%);
}

/* 箭头图标 */
.arrow-icon {
  color: #909399;
  font-size: 14px;
  z-index: 1; /* 箭头在横线上方 */
  background-color: #fff; /* 防止箭头和横线重叠处有线条 */
  padding: 0 5px;
}

.validity {
  font-size: 12px;
  color: #909399;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .to-get-car {
    font-size: 14px;
    font-weight: bolder;
    color: #fff;
  }
  .to-get-car:hover {
    color: #409eff;
  }
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
  min-height: 396px;
}
/* 核心：修复弹框层级问题 */
/* 注意：这里不能加scoped，否则无法生效，单独写在非scoped样式中 */


.contact-dialog {
  z-index: 10000;
}
/* 弹框整体样式 */
.contact-dialog >>> .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
  z-index: 10000; /* 标题栏层级更高 */
}

.contact-dialog >>> .el-dialog__title {
  font-size: 18px;
  color: #303133;
}

.contact-dialog >>> .el-dialog__body {
  padding: 20px;
  z-index: 10000; /* 内容区域层级 */
}

.dialog-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 10000; /* 确保内容在最上层 */
}

/* 左侧二维码 */
.qrcode-wrapper {
  width: 45%;
  display: flex;
  justify-content: center;
}

.qrcode-container {
  position: relative;
  width: 200px;
  height: 200px;
  padding: 8px;
  background: #fff;
  z-index: 1; /* 二维码容器层级 */
}

.qrcode-img {
  width: 100%;
  height: 100%;
  display: block;
}

.qrcode-center-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.qrcode-center-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右侧联系方式 */
.contact-info {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.phone-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.email-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.contact-text {
  font-size: 14px;
  color: #606266;
  word-break: break-all;
}
</style>